module.exports = __webpack_public_path__ + "static/media/image0.a451c411.jpeg";